import { createContext } from 'react'

import { type BrokersBroker } from 'utils/web_api.schemas'

export type BrokerContextType = {
  currentBroker?: BrokersBroker
}

const BrokerContext = createContext<BrokerContextType>({
  currentBroker: undefined,
})

export default BrokerContext
